export default __webpack_public_path__ + "static/agent-b623058263bcafb90eb8ff579bb10b96.svg";